import React, { useEffect } from 'react';
import { useLoader } from '../../../hooks';

// Shown while a lazily loaded page's code downloads. It used to switch the
// full-screen overlay on immediately, so even a 100 ms load flashed a dark
// layer and a large spinner over the half-built page. Waiting 300 ms first
// means quick loads show nothing and only a genuinely slow one gets the
// overlay.
const SHOW_AFTER_MS = 300;

const LoadingFallback: React.FC = () => {
    const { showLoader, hideLoader } = useLoader();

    useEffect(() => {
        let shown = false;
        const timer = setTimeout(() => {
            shown = true;
            showLoader();
        }, SHOW_AFTER_MS);
        return () => {
            clearTimeout(timer);
            if (shown) hideLoader();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
}

export default LoadingFallback;
